module.exports = __webpack_public_path__ + "static/media/feefo_platinum_service_2021_rectangle_L_sml_dark.5aaef51a.svg";